import { Typography } from '@mui/material';
import { ClearLink } from './ClearLink';
import React from 'react';

export const SubLabelWithClearLink: React.FC<{
  subLabel?: string | JSX.Element;
  isClearable: boolean;
  onClearClicked: () => void;
  clearLabel?: string;
}> = ({ subLabel, onClearClicked, clearLabel, isClearable }) => {
  return (
    <Typography>
      {subLabel}{' '}
      {isClearable && (
        <ClearLink onClearClicked={onClearClicked} clearLabel={clearLabel} />
      )}
    </Typography>
  );
};
